import { render, staticRenderFns } from "./ChooseTemplatesModal.vue?vue&type=template&id=1926d366&scoped=true&"
import script from "./ChooseTemplatesModal.vue?vue&type=script&lang=js&"
export * from "./ChooseTemplatesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1926d366",
  null
  
)

export default component.exports